<h5 class="font-weight-bold mt-2">{{ 'ProjectsDashboard.summary.title' | translate }}</h5>

@if (project(); as projectData) {
  <div class="row mt-4">
    <div class="col-md-6">
      <div class="dashboard-card">
        <div class="dashboard-card__header">
          <h5>{{ 'ProjectsDashboard.summary.projectData.title' | translate }}</h5>
          <svg-icon src="./assets/img/ic-edit-v2.svg" (click)="editProject()" />
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.projectData.created' | translate }}
              </div>
              <div class="details-content">
                {{ projectData.created ? (projectData.created | date: 'dd.MM.yyyy HH:mm') : '-' }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.projectData.address' | translate }}
              </div>
              <div class="details-content">
                @if (projectData.fullAddress) {
                  <div class="details-content--copyable-line">
                    <span [copyInline]="projectData.fullAddress">{{ projectData.address || '-' }}</span>
                  </div>
                  <div>{{ projectData.postalCode || '' }} {{ projectData.town || '' }}</div>
                } @else {
                  -
                }
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="dashboard-card__details">
              <div class="details-title">{{ 'ProjectsDashboard.summary.projectData.area' | translate }}</div>
              <div class="details-content">{{ projectData.basicDataBox?.area || '-' }} {{ 'm²' }}</div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="dashboard-card__details">
              <div class="details-title">{{ 'ProjectsDashboard.summary.projectData.floor' | translate }}</div>
              <div class="details-content">{{ projectData.basicDataBox?.floor || '-' }}</div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.projectData.nameOnDoorBell' | translate }}
              </div>
              <div class="details-content">{{ projectData.basicDataBox?.nameOnDoorbell || '-' }}</div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.projectData.realizationTerm' | translate }}
              </div>
              <div class="details-content">
                @if (projectData.basicDataBox?.termStart || projectData.basicDataBox?.termEnd) {
                  {{
                    projectData.basicDataBox?.termStart
                      ? (projectData.basicDataBox?.termStart | date: 'dd.MM.yyyy')
                      : '-'
                  }}
                  -
                  {{
                    projectData.basicDataBox?.termEnd
                      ? (projectData.basicDataBox?.termEnd | date: 'dd.MM.yyyy')
                      : '-'
                  }}
                } @else {
                  -
                }
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.projectData.budget' | translate }}
              </div>
              <div class="details-content details-content--budget">
                @if (
                  projectData.basicDataBox?.budgetAmount !== null &&
                  projectData.basicDataBox?.budgetAmount !== undefined
                ) {
                  <span class="budget-value" [class.budget-value--hidden]="!isBudgetVisible()">
                    {{ projectData.basicDataBox?.budgetAmount | priceFormat: true }}
                    {{ getCurrency(projectData.basicDataBox?.budgetType) }}
                  </span>
                  <svg-icon
                    class="budget-toggle-btn"
                    [src]="isBudgetVisible() ? '/assets/img/ic-eye-off.svg' : '/assets/img/eye-icon.svg'"
                    (click)="toggleBudgetVisibility()"
                  />
                } @else {
                  -
                }
              </div>
            </div>
          </div>
        </div>

        <div class="dashboard-card__divider"></div>

        <div class="row">
          <div class="col-12">
            <div class="dashboard-card__details">
              @let responsibleEmployee = projectData.basicDataBox?.responsibleEmployee;
              <div class="details-title details-title--copyable">
                {{ 'ProjectsDashboard.summary.projectData.responsibleEmployee' | translate }}
                @if (responsibleEmployee) {
                  <svg-icon
                    class="copy-icon copy-icon--header"
                    src="/assets/img/ic-copy_to_clipboard_blue.svg"
                    (click)="
                      copyContactData(
                        responsibleEmployee.userPerson?.previewName,
                        responsibleEmployee.userPerson?.fullPhone,
                        responsibleEmployee.userPerson?.email
                      )
                    "
                  />
                }
              </div>

              @if (responsibleEmployee) {
                <div class="details-content mb-1" [copyInline]="responsibleEmployee.userPerson?.previewName">
                  <span>{{ responsibleEmployee.userPerson?.previewName || '-' }}</span>
                </div>
                <div class="details-content mb-1" [copyInline]="responsibleEmployee.userPerson?.fullPhone">
                  <a
                    *ngIf="responsibleEmployee.userPerson?.fullPhone; else responsibleEmployeePhoneFallback"
                    draggable="false"
                    class="copyable-phone-link no-select"
                    href="tel:{{ responsibleEmployee.userPerson?.fullPhone }}"
                  >
                    {{ responsibleEmployee.userPerson?.fullPhone }}
                  </a>
                  <ng-template #responsibleEmployeePhoneFallback><span>-</span></ng-template>
                </div>
                <div class="details-content" [copyInline]="responsibleEmployee.userPerson?.email">
                  <a
                    *ngIf="responsibleEmployee.userPerson?.email; else responsibleEmployeeEmailFallback"
                    draggable="false"
                    class="copyable-phone-link no-select"
                    href="mailto:{{ responsibleEmployee.userPerson?.email }}"
                  >
                    {{ responsibleEmployee.userPerson?.email }}
                  </a>
                  <ng-template #responsibleEmployeeEmailFallback><span>-</span></ng-template>
                </div>
              } @else {
                <div class="details-content">-</div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="dashboard-card">
        <div class="dashboard-card__header">
          <div class="header-title">
            <h5>{{ 'ProjectsDashboard.summary.customerData.title' | translate }}</h5>
            <svg-icon
              class="copy-icon copy-icon--header"
              src="/assets/img/ic-copy_to_clipboard_blue.svg"
              (click)="copyCustomerSectionData()"
            />
          </div>
          <div class="header-actions">
            <svg-icon src="./assets/img/ic-edit-v2.svg" (click)="editMainContact()" />
            @if (projectData.MainContact?.id) {
              <svg-icon
                class="contact-preview-icon"
                [src]="'/assets/img/ic-external-link.svg'"
                (click)="contactPreview()"
              />
            }
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.customerData.clientData' | translate }}
              </div>
              <div class="details-content" [copyInline]="projectData.MainContact?.fullName">
                <span>{{ projectData.MainContact?.fullName || '-' }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.customerData.address' | translate }}
              </div>
              <div class="details-content" [copyInline]="projectData.MainContact?.fullAddress">
                <span>{{ projectData.MainContact?.fullAddress || '-' }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.customerData.email' | translate }}
              </div>
              <div class="details-content" [copyInline]="projectData.MainContact?.email">
                <a
                  *ngIf="projectData.MainContact?.email; else mainContactEmailFallback"
                  draggable="false"
                  class="copyable-phone-link no-select"
                  href="mailto:{{ projectData.MainContact?.email }}"
                >
                  {{ projectData.MainContact?.email }}
                </a>
                <ng-template #mainContactEmailFallback><span>-</span></ng-template>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.customerData.phone' | translate }}
              </div>
              <div class="details-content" [copyInline]="projectData.MainContact?.fullPhone">
                <a
                  *ngIf="projectData.MainContact?.fullPhone; else mainContactPhoneFallback"
                  draggable="false"
                  class="copyable-phone-link no-select"
                  href="tel:{{ projectData.MainContact?.fullPhone }}"
                >
                  {{ projectData.MainContact?.fullPhone }}
                </a>
                <ng-template #mainContactPhoneFallback><span>-</span></ng-template>
              </div>
            </div>
          </div>
        </div>

        <div class="dashboard-card__divider"></div>

        <div class="row">
          <div class="col-12">
            <div class="dashboard-card__details">
              @let responsibleContact = projectData.basicDataBox?.responsibleContact;
              <div class="details-title details-title--copyable">
                {{ 'ProjectsDashboard.summary.customerData.responsibleContact' | translate }}
                @if (responsibleContact) {
                  <svg-icon
                    class="copy-icon copy-icon--header"
                    src="/assets/img/ic-copy_to_clipboard_blue.svg"
                    (click)="
                      copyContactData(
                        responsibleContact.fullName,
                        responsibleContact.fullPhone,
                        responsibleContact.email
                      )
                    "
                  />
                }
              </div>

              @if (responsibleContact) {
                <div class="details-content mb-1" [copyInline]="responsibleContact.fullName">
                  <span>{{ responsibleContact.fullName || '-' }}</span>
                </div>
                <div class="details-content mb-1" [copyInline]="responsibleContact.fullPhone">
                  <a
                    *ngIf="responsibleContact.fullPhone; else responsibleContactPhoneFallback"
                    draggable="false"
                    class="copyable-phone-link no-select"
                    href="tel:{{ responsibleContact.fullPhone }}"
                  >
                    {{ responsibleContact.fullPhone }}
                  </a>
                  <ng-template #responsibleContactPhoneFallback><span>-</span></ng-template>
                </div>
                <div class="details-content" [copyInline]="responsibleContact.email">
                  <a
                    *ngIf="responsibleContact.email; else responsibleContactEmailFallback"
                    draggable="false"
                    class="copyable-phone-link no-select"
                    href="mailto:{{ responsibleContact.email }}"
                  >
                    {{ responsibleContact.email }}
                  </a>
                  <ng-template #responsibleContactEmailFallback><span>-</span></ng-template>
                </div>
              } @else {
                <div class="details-content">-</div>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <project-summary-logbook [projectId]="projectData.id" />
      </div>
    </div>

    <div class="col-12 mt-4">
      <project-summary-documents />
    </div>
  </div>
} @else {
  <div class="d-flex align-items-center justify-content-center my-5">
    <div class="lds-dual-ring"></div>
  </div>
}
